import { Box } from '@vitvio/design-system';
import { UpdateBanner } from '@vitvio/shared-components';
import { useBuildMetadata } from '@vitvio/build-metadata';

export function LayoutFooter() {
  const { version } = useBuildMetadata();
  return (
    <Box paddingTop="16px">
      <UpdateBanner currentBuildId={version} />
    </Box>
  );
}
